 

export default {
  isLoggining: false,
  status: "",
  token: localStorage.getItem('7asety_token') || '',
  user: ( localStorage.getItem('7asety_user')  != 'undefined' )? JSON.parse( localStorage.getItem('7asety_user') ): {},
}
